export const API_MODE = {
  PROPERTY_LIST: 'property-list',
  PROPERTY: 'property',
  PROPERTY_CREATE: 'property-create',
  PROPERTY_TRANSFER: 'property-transfer',
  PROPERTY_UPDATE: 'property-update',
};

export const PROPERTIES_DIALOG_MODES = {
  CREATE: 'create',
  IMPORT: 'import',
  TRANSFER: 'transfer',
};

export const PROPERTIES_DIALOG_TITLES = {
  [PROPERTIES_DIALOG_MODES.CREATE]: 'Add New Property',
  [PROPERTIES_DIALOG_MODES.IMPORT]: 'Import Properties',
  [PROPERTIES_DIALOG_MODES.TRANSFER]: 'Transfer Property',
};

export const PROPERTIES_API_ERROR_MESSAGES = {
  GET_PROPERTY_LIST:
    'We are unable to fetch properties at this time. Please try again later.',
  GET_PROPERTY:
    'We are unable to fetch the property at this time. Please try again later.',
  UPDATE_PROPERTY:
    'We are unable to update the property at this time. Please try again later.',
  CREATE_PROPERTY:
    'We are unable to create the property at this time. Please try again later.',
};

export const PROPERTIES_API_SUCCESS_MESSAGES = {
  CREATE_PROPERTY: 'Property created',
};

export const TABS = {
  ADVANCED: 'advanced_settings',
  AFFORDABLE: 'affordable',
  AMENITIES: 'amenities',
  LEASING: 'leasing',
  OVERVIEW: 'overview',
};

export const TAB_LIST = [
  TABS.OVERVIEW,
  TABS.AMENITIES,
  TABS.LEASING,
  TABS.AFFORDABLE,
  TABS.ADVANCED,
];

export const TAB_TITLES = {
  [TABS.ADVANCED]: 'Advanced Settings',
  [TABS.AFFORDABLE]: 'Affordable Housing',
  [TABS.AMENITIES]: 'Amenities',
  [TABS.LEASING]: 'Leasing',
  [TABS.OVERVIEW]: 'Overview',
};

export const TAB_VIEW_SECTIONS = {
  [TABS.ADVANCED]: {
    CROSS_SELL: 'crossSell',
    GUEST_CARD_REQUIREMENTS: 'guestCardRequirements',
    SELF_GUIDED_TOURS: 'selfGuidedTours',
  },
  [TABS.AFFORDABLE]: {
    AFFORDABLE_OVERVIEW: 'affordableOverview',
    INCOME_ELIGIBILITY: 'incomeEligibility',
  },
  [TABS.OVERVIEW]: {
    CONTACT_INFO: 'contactInfo',
    FEATURES: 'features',
    HOURS: 'hours',
    MARKETING_MEDIA: 'marketingMedia',
    PROPERTY_DETAILS: 'propertyDetails',
  },
};

export const FIELDS = {
  [TABS.OVERVIEW]: {
    [TAB_VIEW_SECTIONS[TABS.OVERVIEW].PROPERTY_DETAILS]: {
      CITY: 'city',
      DESCRIPTION: 'description',
      NEIGHBORHOOD: 'neighborhood',
      PROPERTY_NAME: 'propertyName',
      STATE: 'state',
      STREET: 'street',
      TOTAL_UNITS: 'totalUnits',
      UNIT_TYPES: 'unitTypes',
      YEAR_BUILT: 'yearBuilt',
      ZIP: 'zip',
    },
    [TAB_VIEW_SECTIONS[TABS.OVERVIEW].MARKETING_MEDIA]: {
      BRAND_COLOR: 'brandColor',
      CUSTOM_LINKS: 'customLinks',
      LOGOS: `logos`,
      PHOTOS: 'photos',
      PROPERTY_WEBSITE: 'propertyWebsite',
      SOCIAL_MEDIA: 'socialMedia',
    },
    [TAB_VIEW_SECTIONS[TABS.OVERVIEW].CONTACT_INFO]: {
      KNOCK_EMAIL: 'knockEmail',
      OWNER: 'owner',
    },
    [TAB_VIEW_SECTIONS[TABS.OVERVIEW].FEATURES]: {
      NOTES: 'notes',
      LOCATIONS: 'location',
      UNITS: 'units',
      COMMUNITY: 'community',
    },
  },
  [TABS.AFFORDABLE]: {
    [TAB_VIEW_SECTIONS[TABS.AFFORDABLE].AFFORDABLE_OVERVIEW]: {
      DETAILS: 'details',
    },
    [TAB_VIEW_SECTIONS[TABS.AFFORDABLE].INCOME_ELIGIBILITY]: {
      MAXIMUM_INCOME: 'maximumIncome',
      OCCUPANTS: 'occupants',
    },
  },
  [TABS.ADVANCED]: {
    [TAB_VIEW_SECTIONS[TABS.ADVANCED].CROSS_SELL]: {
      CROSS_SELL_RADIUS: 'crossSellRadius',
      CROSS_SELL_REFERRAL_SOURCE: 'crossSellReferralSource',
      NEARBY_PROPERTIES_EXCLUDED_PROPERTIES:
        'nearbyPropertiesExcludedProperties',
    },
    [TAB_VIEW_SECTIONS[TABS.ADVANCED].GUEST_CARD_REQUIREMENTS]: {
      REQUIRE_BEDROOM_COUNT: 'requirePreferredBedroomCount',
      REQUIRE_LEASE_TERM: 'requireLeaseTerm',
      REQUIRE_MOVE_IN_DATE: 'requireProspectMoveInDate',
      REQUIRE_FLOOR_PLAN: 'requireProspectFloorplan',
      REQUIRE_PREFERRED_UNIT: 'requirePreferredUnit',
    },
    [TAB_VIEW_SECTIONS[TABS.ADVANCED].SELF_GUIDED_TOURS]: {
      SELF_GUIDED_TOUR_BUTTON_LABEL: 'selfGuidedTourButtonLabel',
      SELF_GUIDED_TOUR_URL: 'selfGuidedTourUrl',
      TOURS_EXPORT_ONLY_FAVORITE_UNIT: 'toursExportOnlyFavoriteUnit',
    },
  },
};

export const SOCIAL_MEDIA_TYPES = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  X: 'x',
  YELP: 'yelp',
};

export const CUSTOM_LINK_FIELDS = {
  TITLE: 'title',
  URL: 'url',
};

export const PROPERTY_ID = 'propertyId';

export const IMAGE_DIALOG_TYPES = {
  LOGO: 'logos',
  PHOTOS: 'photos',
};

export const DEFAULT_CROSS_SELL_RADIUS = 20;
